/* @flow */
import { Map, fromJS, OrderedMap } from 'immutable';
import createDebugger from 'debug';
const debug = createDebugger('app:modules:create:actions'); // eslint-disable-line no-unused-vars

import { INITIAL_FORM_VALUES, INITIAL_INDICATORS_FORM_VALUES } from './constants.js';
import {
  SET_STAGE,
  REVIEW_REPORT,
  TOGGLE_REDACTION,
  SUBMIT_REPORT,
  SUBMIT_INDICATORS,
  SUBMIT_INDICATORS_FILE,
  UPDATE_REPORT,
  ATTACH_INDICATORS_SPREADSHEET_FILE,
  LOAD_REPORT_DATA,
  ATTACH_FILE,
  ATTACH_FILE_FAILURE,
  REGISTER_FORM,
  SET_FIELD_VALUE,
  UNREGISTER_FORM,
  SET_SUBMISSION_TYPE,
} from './action-types.js';
import type { Enclave } from 'modules/enclave/types';

export const toggleRedaction = (): Object => ({ type: TOGGLE_REDACTION });

export const setStage = (stage: ?string): Object => ({
  type: SET_STAGE,
  payload: stage,
});

export const setSubmissionType = (type: ?string): Object => ({
  type: SET_SUBMISSION_TYPE,
  payload: type,
});

/* Proceed to Review/Redact stage of report creation */
export const review = (report: Map<any, any>): Object => ({
  type: REVIEW_REPORT,
  payload: report,
});

/* Submit a report */
export const submitReport = (report: Map<any, any>): Object => ({
  type: SUBMIT_REPORT,
  payload: report
});

/* Submit indicators */
export const submitIndicators = (values: Map<string, Object>): Object => ({
  type: SUBMIT_INDICATORS,
  payload: values
});

/* Submit indicators */
export const submitIndicatorsFile = (values: Map<string, Object>): Object => ({
  type: SUBMIT_INDICATORS_FILE,
  payload: values
});

/* Update a report */
export const update = (report: Map<any, any>) => ({
  type: UPDATE_REPORT,
  payload: report,
});

/* Handle attaching a file */
export const attachFile = ([ file ]: File[]) => ({
  type: ATTACH_FILE,
  payload: file,
});

/* Handle attaching a spreadsheet file intended for
 * specific indicator extraction and parsing */
export const handleSpreadsheetUpload = ([ file ]: File[]) => ({
  type: ATTACH_INDICATORS_SPREADSHEET_FILE,
  payload: file,
});

export const uploadRejected = () => ({ type: ATTACH_FILE_FAILURE });

export const loadReportData = (guid: string, release: boolean = false) => ({
  type: LOAD_REPORT_DATA,
  payload: { guid, release }
});

const getFormEnclaves = enclaves => enclaves.map(x => x.get('id')).toList();

export const registerForm = (enclaves: OrderedMap<string, Enclave>) => {
  // Initalize the user's enclaves in the form values here:
  const userEnclaves = getFormEnclaves(enclaves);
  const formValues = {
    ...INITIAL_FORM_VALUES,
    enclaves: userEnclaves,
  };

  // Default distribution type to community if user has no enclaves
  if (formValues.distributionType === 'ENCLAVE' && !userEnclaves.size) {
    // TODO: Should we remove this piece of code?
    formValues.distributionType = 'COMMUNITY';
  }

  return {
    type: REGISTER_FORM,
    payload: { values: formValues },
  };
};

export const registerIndicatorsForm = (enclaves: OrderedMap<string, Enclave>) => {
  // Initalize the user's enclaves in the form values here:
  const userEnclaves = getFormEnclaves(enclaves);
  const formValues = {
    ...INITIAL_INDICATORS_FORM_VALUES,
    enclaves: userEnclaves,
  };
  return {
    type: REGISTER_FORM,
    payload: { values: formValues },
  };
};

export const teardown = (): Object => ({ type: UNREGISTER_FORM });

export const updateField = (keyPath: ?string[], value: any): Object => ({
  type: SET_FIELD_VALUE,
  payload: { keyPath, value }
});

/* Reset the 'content' key on our form state map */
export const removeContent = () => ({
  type: SET_FIELD_VALUE,
  payload: {
    keyPath: ['content'],
    value: fromJS(INITIAL_FORM_VALUES.content),
  },
});



// WEBPACK FOOTER //
// ./src/app/modules/create/actions.js